module.exports = __webpack_public_path__ + "media/images/creator/monitor/limited@3x-2b4383df3aee652636be110264eab460.png";